export const keyPrefix = 'officeHome';
export const officeUserSideloadDataCookieKeyFormat = `${keyPrefix}-{0}sideloadedApps`;
export const m365AppsDataDivId = 'm365AppsData';
export const AppsWithBuiltInContentActions = {
    PDFWorks: 'ca4b5141-5c46-47bc-a05e-2733d9bd69aa',
    ToDo: '7d30d5c91ee-5be2-4b79-81ed-23e6c4580427',
};
export const jaguarsharkAppId = '07b75f22-72b5-4063-b7fc-0ed5ea8ff3ff';
export const copilotM365AppId = 'd870f6cd-4aa5-4d42-9626-ab690c041429';
export const prepareM365AppId = '1fae1e74-c74e-41ba-875e-804783f8170a';
export const createMOSAppId = '04e4f8d4-aadf-4528-8f3a-48e340554cea';
//# sourceMappingURL=keys.js.map